const valueType = Object.freeze({
  Absolute: "Absolute",
  Increment: "Increment",
  Decrement: "Decrement",
  PercentageIncrease: "Percentage Increase",
  PercentageDecrease: "Percentage Decrease",
});

export default valueType;